(function() {
    'use strict';

    angular.module('irricrops')
    .directive('comparacion', [function() {
      var directive = {
        restrict         : 'E',
        templateUrl      : 'shared/comparacion/comparacion.view.html',
        controller       : "comparacionCtrl",
        controllerAs     : 'vc',
        bindToController : true,
        scope : {
          configComparacion: "=config",
          showChart: "=?resumen",
          listModeAux: "=?listMode"
        }
      };
      return directive;
    }])

  .controller("comparacionCtrl",
  ["$scope","MultiChart", "Config", "$state", "estadisticaFac","$stateParams",
  "$mdDialog","CuartelFac","$timeout","cuartelDialog", "$rootScope","$q",
  function($scope, MultiChart, Config, $state, estadisticaFac, $stateParams,
    $mdDialog, CuartelFac, $timeout, cuartelDialog, $rootScope, $q){

      var vm                   = this;
      var facFn                = vm.configComparacion.facFn;
      var dataHttp             = vm.configComparacion.http;
      vm.chartConfig           = "";
      vm.estados               = [];
      vm.meses                 = [];
      vm.inicio                = moment("2017-01-01").toDate();
      vm.termino               = moment("2017-03-31").toDate();
      vm.sectoresList          = [];
      vm.charts                = {};
      vm.resumen               = angular.copy(vm.showChart);
      vm.sectoresSeleccionados = [];
      vm.showBackdrop          = false;
      vm.hideBackDrop          = null; //funcion dinamica, se llena al hacer click en el label del grafico
      vm.listMode              = vm.listModeAux || true;

      var getSectoresSeleccionados = function () {
        vm.sectoresSeleccionados = [];
        angular.forEach(vm.equipos, function(equipo) {
          angular.forEach(equipo.sectores_riego, function(sector) {
            if (sector.selected) {
              vm.sectoresSeleccionados.push(sector.id);
            }
          });
        });
        return vm.sectoresSeleccionados;
      }

      vm.seleccionarTodosSectores = function() {
        vm.sectoresSeleccionados = [];
        angular.forEach(vm.equipos, function(equipo) {
          angular.forEach(equipo.sectores_riego, function(sector) {
            vm.sectoresSeleccionados.push(sector.id);
            sector.selected = true;
          });
        });
      }


      vm.verTodosSectores = function() {
        vm.seleccionarTodosSectores();
        vm.graficar();
      }

      vm.todosSeleccionados = function() {
        var todos = true;
        angular.forEach(vm.equipos, function(equipo) {
          angular.forEach(equipo.sectores_riego, function(sector) {
            if (sector.selected == false) {
              todos = false;
            }
          });
        });
        return todos;
      }


      if (vm.configComparacion.equipos !== undefined) {
        vm.mostrarBtnSectores = true;
        vm.equipos = vm.configComparacion.equipos;
        vm.seleccionarTodosSectores();
      }else {
        vm.equipos = null;
      }

      vm.popoverStyleSample = {
        sectores:{
          left : 20,
          top  : 20
        }
      };

      vm.periodos = [
        {
          id: 5,
          nombre: "Resumen" //usado para no mostrar nada
        },
        {
          id: 1,
          nombre: "Temporada"
        },
        {
          id: 2,
          nombre: "Meses"
        },
        {
          id: 3,
          nombre: "Entre Fechas"
        },
        {
          id: 4,
          nombre: "Estado Fenologico"
        },
      ];


      if (vm.resumen=== undefined) {
        vm.showChart = true;
        vm.periodos.splice(0, 1);
      }else{
        vm.showChart = false;
      }
      vm.periodoSelected = vm.periodos[0];
      vm.mesSelected     = null;
      vm.estadoSelected  = null;

      var DialogController = ["$scope", "$mdDialog", "equipos", function($scope, $mdDialog, equipos) {
        var vm = this;
        vm.equipos = equipos;
        vm.equiposEdicion = angular.copy(equipos);

        vm.selectEquipo = function(equipo) {
          if (equipo.selected === undefined) {
            equipo.selected = false;
          }
          equipo.selected = !equipo.selected;
          angular.forEach(equipo.sectores_riego, function(sector) {
            sector.selected = equipo.selected;
          });
        }

        vm.isEquipoIndeterminate = function(equipo) {
          var allChecked = true;
          var nothingChecked = true;
          angular.forEach(equipo.sectores_riego, function(sector) {
            if (!sector.selected) {
              allChecked = false
            }
            if (sector.selected) {
              nothingChecked = false
            }
          });
          return !allChecked && !nothingChecked;
        }

        vm.isEquipoChecked = function(equipo) {
          var allChecked = true;
          angular.forEach(equipo.sectores_riego, function(sector) {
            if (!sector.selected) {
              allChecked = false
            }
          });
          return allChecked;
        }

        $scope.cancel = function() {
          $mdDialog.cancel();
        };

        $scope.aceptar = function() {
          angular.forEach(vm.equipos, function(equipo) {
            angular.forEach(vm.equiposEdicion, function(equipoE) {
              if (equipoE.id == equipo.id) {
                equipo.selected = equipoE.selected;
              }
              angular.forEach(equipo.sectores_riego, function(sector) {
                angular.forEach(equipoE.sectores_riego, function(sectorE) {
                  if (sector.id == sectorE.id) {
                    sector.selected = sectorE.selected;
                  }
                });
              });
            });
          });
          $mdDialog.hide({graficar:true});
        };
      }];

      vm.showSelectSectores = function(ev) {
        $mdDialog.show({
          controller          : DialogController,
          controllerAs        : "dd",
          templateUrl         : 'shared/comparacion/selectSector.tmpl.html',
          parent              : angular.element(document.body),
          targetEvent         : ev,
          clickOutsideToClose : true,
          locals: {
            equipos : vm.configComparacion.equipos
          }
        })
        .then(function(answer) {
          if (answer.graficar) {
            getSectoresSeleccionados();
            vm.graficar();
          }
        }, function() {
        });
      }





      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#startMultiChart
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * funcion que inicia el grafico
      * además inserta el evento redraw al grafico, con el que se agregan eventos
      * a los label de eje X, con click, mouseover y mouseleave
      *
      * @param {object} dataChart object con los datos para iniciar el grafico
      * @returns {object} mchart object
      **/
      vm.startMultiChart = function(dataChart, chartItem) {
        var mchart = new MultiChart(dataChart.title);
        mchart.showComparison();
        var chartConfig = mchart.getConfig();
        if (dataChart.subtitle) {
          mchart.setSubtitle(dataChart.subtitle);
        }

        mchart.setPositioner(function(w) {
          return { x: this.chart.plotWidth - w, y:50 };
        });

        // Estilos para mouseover, mouseleave y click
        // para labels del eje X del grafico
        chartConfig.options.chart.events.redraw = function(a) {
          var chart = a.target;
          var axis = chart.xAxis[0];
          var onYaxisRedraw = function() {
            for (var tickPos in axis.ticks) {
              if (axis.ticks[tickPos].label) {
                var $element = $(axis.ticks[tickPos].label.element);
                $element.unbind('click');
                $element.unbind('mouseleave');
                $element.unbind('mouseover');

                $element.css({
                  fill: "#0d47a1",
                  "font-size": "14px",
                  "text-decoration": "underline",
                  cursor: "pointer"
                });

                $element.on("mouseleave", function() {
                  $(this).css({
                    "font-size": "14px",
                  });
                });
                $element.on("mouseover", function() {
                  $(this).css({
                    "font-size": "16px",
                  });
                });

                $element.on("click", function(a) {
                  $timeout(function() {
                    chartItem.popoverList.sectores = chartItem.sectoresList[a.currentTarget.textContent];
                    if (chartItem.popoverStyle.sectores.isVisible) {
                      chartItem.popoverStyle.sectores.left = 0;
                      chartItem.popoverStyle.sectores.top = 0;
                      chartItem.popoverStyle.sectores.opacity = 0;
                      chartItem.popoverStyle.sectores.display = "none";
                      chartItem.popoverStyle.sectores.isVisible = false;
                      vm.showBackdrop = false;
                    }else{

                      var $ls = $(a.target).closest(".grafico-comparacion").find(".popover-lista-sectores");
                      $ls.removeClass("left");
                      chartItem.popoverStyle.sectores.left = $(a.target).position().left - $("#content").position().left +  $(a.target)[0].getBBox().width + 20;
                      if ($(window).width()/2 < $(a.target).position().left) {
                        chartItem.popoverStyle.sectores.left -= ($ls.width() + $(a.target)[0].getBBox().width + 70);
                        $ls.addClass("left");
                      }

                      var delayFn = function() {
                        chartItem.popoverStyle.sectores.top = $(a.target).position().top - $("#content").position().top - ($ls.height() - 30) + $("#content").scrollTop();
                        chartItem.popoverStyle.sectores.left = $(a.target).position().left - $("#content").position().left +  $(a.target)[0].getBBox().width + 20;
                        if ($(window).width()/2 < $(a.target).position().left) {
                          chartItem.popoverStyle.sectores.left -= ($ls.width() + $(a.target)[0].getBBox().width + 70);
                        }
                      }
                      $timeout(delayFn, 100);
                      $timeout(delayFn, 500);

                      chartItem.popoverStyle.sectores.top = $(a.target).position().top - $("#content").position().top - ($ls.height() - 30) + $("#content").scrollTop();
                      chartItem.popoverStyle.sectores.display = "block";
                      chartItem.popoverStyle.sectores.opacity = 1;
                      chartItem.popoverStyle.sectores.isVisible = true;
                      vm.showBackdrop = true;
                      vm.hideBackDrop = function() {
                        chartItem.popoverStyle.sectores.left = 0;
                        chartItem.popoverStyle.sectores.top = 0;
                        chartItem.popoverStyle.sectores.opacity = 0;
                        chartItem.popoverStyle.sectores.display = "none";
                        chartItem.popoverStyle.sectores.isVisible = false;
                        vm.showBackdrop = false;
                      }
                    }
                  });
                });

              }
            }
          }
          onYaxisRedraw();
          axis.redraw(onYaxisRedraw);
        }

        var params = [
          {
            nameParam : "riego"
          },
          {
            nameParam: "et"
          },
          {
            nameParam: "vol"
          },
          {
            nameParam: "scholander"
          },
          {
            nameParam: "precip"
          },
          {
            nameParam: "prod"
          },
          {
            nameParam:"rep"
          }
        ];

        var dataParams = [];
        angular.forEach(params, function(param) {
          if (dataParams[param.nameParam] == undefined) {
            dataParams[param.nameParam] = [];
          }
          var defaultData = param.defaultData || null;
          angular.forEach(dataChart[param.nameParam], function (data, index) {
            if (data === null || data === 0) {
              dataParams[param.nameParam].push([dataChart.axis[index], defaultData]);
            }else{
              dataParams[param.nameParam].push([dataChart.axis[index], parseFloat(data)]);
            }
          });
        });

        mchart.agregarSerie({
          color       : Config.colors.riegoReal.background,
          name        : 'Riego Real',
          yAxis       : 2,
          type        : 'column',
          data        : dataParams["riego"],
          width       : 15,
          visibleAxis : true,
          suffix      : ' mm por sector'
        });


        mchart.agregarSerie({
          color  : Config.colors.volumen.background,
          name   : 'Volumen m<sup>3</sup> / ha',
          type   : 'column',
          yAxis  : 7,
          width  : 15,
          suffix : ' m<sup>3</sup>/ha',
          data   : dataParams["vol"],
        });

        mchart.agregarSerie({
          color     : Config.colors.precipitacion.background,
          name      : 'Precipitacion (promedio)',
          yAxis     : 2,
          type      : 'column',
          lineWidth : 2,
          width     : 15,
          suffix    : 'mm',
          data      : dataParams["precip"]
        });

          /*
          mchart.agregarSerie({
          color     : Config.colors.produccion.background,
          name      : 'Produccion ton/ha',
          type      : 'column',
          yAxis     : 10,
          width     : 15,
          suffix    : ' ton/ha',
          data      : dataParams["prod"]
        });

        */

        mchart.agregarSerie({
          color        : Config.colors.riegoReal.background,
          name         : 'Reposicion',
          type         : 'spline',
          markerSymbol : 'circle',
          radius       : 2,
          yAxis        : 12,
          lineWidth    : 2,
          suffix       : ' %',
          data         : dataParams["rep"]
        });

        mchart.agregarSerie({
          color        : Config.colors.scholander.background,
          name         : 'Bomba Scholander',
          markerSymbol : 'circle',
          type         : "spline",
          radius       : 6,
          yAxis        : 1,
          preffix      : '-',
          suffix       : ' bar',
          visibleAxis  : true,
          data         : dataParams["scholander"]
        });

        mchart.agregarSerie({
          color     : Config.colors.etAcumulado.background,
          name      : 'ET0 Acumulada',
          markerSymbol : 'circle',
          type         : "spline",
          yAxis     : 2,
          radius    : 2,
          lineWidth : 1,
          suffix    : ' mm',
          data         : dataParams["et"]
        });



        return mchart;
      };

      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#showTemporada
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * Muestra el grafico de la temporada completa
      *
      * @returns {promise} promesa de peticion
      **/
      vm.showTemporada   = function() {
        //$state.go(".", {temporada:1});
        vm.charts = [];
        angular.forEach(vm.configComparacion.arrayHttp.array, function(itemArray) {
          var chart = {
            popoverList : angular.copy(vm.popoverListSample),
            popoverStyle: angular.copy(vm.popoverStyleSample),
          };
          vm.charts.push(chart);
          chart.loadingChart = true;
          vm.loadingChart = true;
          var dataChart = {
            title      : "Gráfico de comparacion por temporada para "+ itemArray.nombre,
            riego      : [],
            et         : [],
            vol        : [],
            scholander : [],
            precip     : [],
            prod       : [],
            rep        : [],
            axis       : []
          };

          var data = angular.copy(dataHttp);
          data[vm.configComparacion.arrayHttp.name] = itemArray.id;
          if (vm.mostrarBtnSectores) {
            if (vm.sectoresSeleccionados.length == 0) {
              vm.seleccionarTodosSectores();
            }
            data["sectores_riego_id[]"] = angular.copy(vm.sectoresSeleccionados);
            chart.prom = estadisticaFac["getTemporadaSectorRiego"](data).$promise;
          }else{
            chart.prom = estadisticaFac["getTemporada"+facFn](data).$promise;
          }

          chart.prom.then(function(res) {
            angular.forEach(res.data, function(item) {
              dataChart.riego.push(_.round(item.mm, 2));
              dataChart.et.push(_.round(item.et, 2));
              dataChart.vol.push(_.round(item["m3/ha"], 2));
              dataChart.scholander.push(_.round(item.scholander, 2));
              dataChart.precip.push(_.round(item.precipitacion, 2));
              dataChart.rep.push(_.round(item.reposicion, 2));
              dataChart.axis.push(item.periodo);
            });
            chart.sectoresList = [];
            angular.forEach(res.data, function(periodo) {
              chart.sectoresList[periodo.periodo] = periodo.secs;
            });
            chart.mchart = vm.startMultiChart(dataChart, chart);
            vm.startRiegoRealChart(dataChart);
            vm.startScholanderChart(dataChart);
            vm.startVolumenChart(dataChart);
            vm.startReposicionChart(dataChart);
            vm.startPrecipitacionChart(dataChart);
            vm.startEtAcumuladaChart(dataChart);
            chart.chartConfig = chart.mchart.getConfig();
            chart.loadingChart = false;
            vm.loadingChart = false;
          });
        });
      }


      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#selectPeriodo
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * Selecciona el periodo segun los items de la variable periodos[]
      * estos indican los botones con los periodos seleccionables
      * temporada, mes, entre fechas y estado fenollogico
      * Antes de llamar las funciones, resetea el estado (ruta) y limpia las
      * variables necesarias
      **/
      vm.selectPeriodo   = function(periodo) {
        $state.go(".", {
          mes       : undefined,
          estado    : undefined,
          inicio    : undefined,
          termino   : undefined,
          temporada : undefined
        });
        //vm.popoverStyle.sectores.display   = "none";
        //vm.popoverStyle.sectores.isVisible = false;
        vm.periodoSelected = periodo;
        vm.graficar();
      }

      vm.graficar = function() {
        vm.showChart = true;
        switch (vm.periodoSelected.id) {
          case 1: //temporada
            vm.showTemporada(vm.mesSelected);
          break;
          case 2: //meses
            if (vm.listMode) {
              vm.selectMeses();
            }else{
              vm.selectMes(vm.mesSelected);
            }
            break;
          case 3: //entre fechas
            vm.changeFechas(vm.inicio, vm.termino);
            break;
          case 4: //estados
            if (vm.listMode) {
              vm.selectEstados();
            }else{
              vm.selectEstado(vm.estadoSelected);
            }
            break;
          case 5: //resumen
            vm.showChart = false;
            break;
          default:
            vm.showTemporada(vm.mesSelected);
        }
      }



      function getChartMes (mes) {
        var charts = []
        angular.forEach(vm.configComparacion.arrayHttp.array, function(itemArray) {
          var chart = {
            popoverList : angular.copy(vm.popoverListSample),
            popoverStyle: angular.copy(vm.popoverStyleSample),
          };
          chart.loadingChart = true;
          vm.mesSelected  = mes;
          var dataChart   = {
            title      : "Gráfico de comparacion para "+ itemArray.nombre +" en "+mes.nombre,
            riego      : [],
            et         : [],
            vol        : [],
            scholander : [],
            precip     : [],
            prod       : [],
            rep        : [],
            axis       : []
          };

          var data = angular.copy(dataHttp);
          data[vm.configComparacion.arrayHttp.name] = itemArray.id;
          data.mes = mes.numero;

          if (vm.mostrarBtnSectores) {
            if (vm.sectoresSeleccionados.length == 0) {
              vm.seleccionarTodosSectores();
            }
            data["sectores_riego_id[]"] = angular.copy(vm.sectoresSeleccionados);
            chart.prom = estadisticaFac["getTemporadaSectorRiego"](data).$promise;
          }else{
            chart.prom = estadisticaFac["getTemporada"+facFn](data).$promise;
          }

          chart.prom.then(function(res) {
            angular.forEach(res.data, function(item) {
              dataChart.riego.push(_.round(item.mm, 2));
              dataChart.et.push(_.round(item.et, 2));
              dataChart.vol.push(_.round(item["m3/ha"], 2));
              dataChart.rep.push(_.round(item.reposicion, 2));
              dataChart.scholander.push(_.round(item.scholander, 2));
              dataChart.precip.push(_.round(item.precipitacion, 2));
              dataChart.axis.push(item.periodo);
            });
            chart.sectoresList = [];
            angular.forEach(res.data, function(periodo) {
              chart.sectoresList[periodo.periodo] = periodo.secs;
            });
            chart.mchart = vm.startMultiChart(dataChart, chart);
            chart.chartConfig = chart.mchart.getConfig();
            chart.loadingChart = false;
          });
          charts.push(chart);
        });
        return charts;
      }

      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#selectMes
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * Muestra el grafico correspondiente a un mes de cada temporada
      *
      * @param {object} mes Mes seleccionado, con inicio y termino
      *
      * @returns {promise} promesa de peticion
      **/
      vm.selectMes = function(mes) {
        $state.go(".", {mes:mes.numero});
        if (vm.mostrarBtnSectores) {
          if (vm.sectoresSeleccionados.length == 0) {
            vm.seleccionarTodosSectores();
          }
        }
        vm.charts = getChartMes(mes);
      }





      vm.selectMeses = function() {
        $state.go(".", {mes:1});
        vm.charts = [];
        var charts = [];

        if (vm.mostrarBtnSectores) {
          if (vm.sectoresSeleccionados.length == 0) {
            vm.seleccionarTodosSectores();
          }
        }
        angular.forEach(vm.meses, function(mes) {
          charts.push(getChartMes(mes)[0]);
        });
        angular.extend(vm.charts, charts);
      }


      function getChartEstado (estado) {
        var charts = [];
        angular.forEach(vm.configComparacion.arrayHttp.array, function(itemArray) {
          var chart = {
            popoverList : angular.copy(vm.popoverListSample),
            popoverStyle: angular.copy(vm.popoverStyleSample),
          };
          charts.push(chart);
          chart.loadingChart = true;
          vm.estadoSelected = estado;
          var dataChart = {
            title      : "Gráfico de comparacion del estado '"+estado.nombre+"' para "+ itemArray.nombre,
            riego      : [],
            et         : [],
            vol        : [],
            scholander : [],
            precip     : [],
            prod       : [],
            rep        : [],
            axis       : []
          };
          var data = angular.copy(dataHttp);
          data.estado=estado.nombre_2;
          data[vm.configComparacion.arrayHttp.name] = itemArray.id;

          if (vm.mostrarBtnSectores) {
            data["sectores_riego_id[]"] = angular.copy(vm.sectoresSeleccionados);
            chart.prom = estadisticaFac["getTemporadaSectorRiego"](data).$promise;
          }else{
            chart.prom = estadisticaFac["getTemporada"+facFn](data).$promise;
          }

          chart.prom.then(function(res) {
            angular.forEach(res.data, function(item) {
              dataChart.riego.push(_.round(item.mm, 2));
              dataChart.et.push(_.round(item.et, 2));
              dataChart.vol.push(_.round(item["m3/ha"], 2));
              dataChart.rep.push(_.round(item.reposicion, 2));
              dataChart.scholander.push(_.round(item.scholander, 2));
              dataChart.precip.push(_.round(item.precipitacion, 2));
              dataChart.axis.push(item.periodo);
            });
            chart.sectoresList = [];
            angular.forEach(res.data, function(periodo) {
              chart.sectoresList[periodo.periodo] = periodo.secs;
            });
            chart.mchart = vm.startMultiChart(dataChart, chart);
            chart.chartConfig = chart.mchart.getConfig();
            chart.loadingChart = false;
          });
        });
        return charts;
      }

      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#selectEstado
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * Muestra el grafico correspondiente a un estado Fenologico de cada temporada
      *
      * @param {object} estado Estado Fenologico seleccionado
      *
      * @returns {promise} promesa de peticion
      **/
      vm.selectEstado    = function(estado) {
        $state.go(".", {estado:estado.nombre});

        if (vm.mostrarBtnSectores) {
          if (vm.sectoresSeleccionados.length == 0) {
            vm.seleccionarTodosSectores();
          }
        }
        vm.charts = getChartEstado(estado);
      }
      vm.selectEstados = function() {
        $state.go(".", {estado:1});
        vm.charts = [];
        var charts = [];

        if (vm.mostrarBtnSectores) {
          if (vm.sectoresSeleccionados.length == 0) {
            vm.seleccionarTodosSectores();
          }
        }
        angular.forEach(vm.estados, function(estado) {
          charts.push(getChartEstado(estado)[0]);
        });
        angular.extend(vm.charts, charts);
      }

      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#changeFechas
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * Muestra el grafico correspondiente a un lapsus de tiempo
      *
      * @param {Date} inicio Fecha de inicio de lapsus de tiempo
      * @param {Date} termino Fecha de termino de lapsus de tiempo
      *
      * @returns {promise} promesa de peticion
      **/
      vm.changeFechas    = function(inicio, termino) {
        vm.inicio       = inicio;
        vm.termino      = termino;
        var mi          = moment(inicio);
        var mt          = moment(termino);
        $state.go(".", {
          inicio  : mi.format("DD-MM-YYYY"),
          termino : mt.format("DD-MM-YYYY")
        });
        vm.charts = [];
        angular.forEach(vm.configComparacion.arrayHttp.array, function(itemArray) {
          var chart = {
            popoverList : angular.copy(vm.popoverListSample),
            popoverStyle: angular.copy(vm.popoverStyleSample),
          };
          vm.charts.push(chart);
        chart.loadingChart = true;


        var dataChart = {
            title      : "Gráfico de comparacion para "+itemArray.nombre,
            subtitle   : "Desde el "+mi.format("DD [de] MMMM")+" hasta el "+mt.format("DD [de] MMMM"),
            riego      : [],
            et         : [],
            vol        : [],
            scholander : [],
            precip     : [],
            prod       : [],
            rep        : [],
            axis       : []
          };

          var data          = angular.copy(dataHttp);
          data.fecha_inicio = inicio;
          data.fecha_fin    = termino;
          data[vm.configComparacion.arrayHttp.name] = itemArray.id;

          if (vm.mostrarBtnSectores) {
            if (vm.sectoresSeleccionados.length == 0) {
              vm.seleccionarTodosSectores();
            }
            data["sectores_riego_id[]"] = angular.copy(vm.sectoresSeleccionados);
            chart.prom = estadisticaFac["getTemporadaSectorRiego"](data).$promise;
          }else{
            chart.prom = estadisticaFac["getTemporada"+facFn](data).$promise;
          }

        chart.prom.then(function(res) {
          angular.forEach(res.data, function(item) {
            dataChart.riego.push(_.round(item.mm, 2));
            dataChart.et.push(_.round(item.et, 2));
            dataChart.vol.push(_.round(item["m3/ha"], 2));
            dataChart.rep.push(_.round(item.reposicion, 2));
            dataChart.scholander.push(_.round(item.scholander, 2));
              dataChart.precip.push(_.round(item.precipitacion, 2));
            dataChart.axis.push(item.periodo);
          });
            chart.sectoresList = [];
            angular.forEach(res.data, function(periodo) {
              chart.sectoresList[periodo.periodo] = periodo.secs;
            });
          chart.mchart = vm.startMultiChart(dataChart, chart);
          chart.chartConfig = chart.mchart.getConfig();
          chart.loadingChart = false;
        });
        });

      }




      function getPeriodo(nombre) {
        var p = null;
        angular.forEach(vm.periodos, function(periodo) {
          if (periodo.nombre == nombre) {
            p = periodo
          }
        });
        return p;
      }

      /**
      * @ngdoc method
      * @name irricrops.vinedoComparacionCtrl#verificarRuta
      * @methodOf irricrops.vinedoComparacionCtrl
      *
      * @description
      * verifica las variables de la ruta y redirecciona a la funcion llamada
      * si no hay variables, llama a la funcion selectPeriodo() con el periodo
      * de temporada com parametro
      *
      * variables:
      *   - mes
      *   - inicio y termino
      *   - estado
      **/
       function verificarRuta () {
         var invalidRoute = true;
         if($stateParams.mes){
           var mesSelected = null;
           angular.forEach(vm.meses, function(mes) {
             if(mes.numero == $stateParams.mes){
               mesSelected = mes;
             }
           });
           if (mesSelected !== null) {
             invalidRoute = false;
             vm.mesSelected = mesSelected;
             vm.selectPeriodo(getPeriodo("Meses"));
           }


         }else if($stateParams.inicio && $stateParams.termino){
           var mi = moment($stateParams.inicio, "DD-MM-YYYY");
           var mt = moment($stateParams.termino, "DD-MM-YYYY");
           if (mi.isValid() && mt.isValid() && mi.isBefore(mt)) {
             invalidRoute = false;
             vm.inicio = mi.toDate();
             vm.termino = mt.toDate();
             vm.selectPeriodo(getPeriodo("Entre Fechas"));
           }


         }else if($stateParams.estado){
           var estadoSelected = null
           angular.forEach(vm.estados, function(estado) {
             if (estado.nombre == $stateParams.estado) {
               estadoSelected = estado;
             }
           });
           if (estadoSelected || (vm.listMode && $stateParams.estado == 1)) {
             invalidRoute = false;
             vm.estadoSelected = estadoSelected;
             vm.selectPeriodo(getPeriodo("Estado Fenologico"));
           }
         }else if($stateParams.temporada){
           invalidRoute = false;
           vm.selectPeriodo(getPeriodo("Temporada"));
         }


         if(invalidRoute){
           if (vm.resumen == undefined) {
            vm.selectPeriodo(getPeriodo("Temporada"));
           }else{
            vm.selectPeriodo(getPeriodo("Resumen"));
           }
         }
       }


       vm.init = function() {
         var data = angular.copy(dataHttp);
         data[vm.configComparacion.arrayHttp.name] = [];
         angular.forEach(vm.configComparacion.arrayHttp.array, function(itemHttp) {
           if (typeof itemHttp.id == typeof []) {
             angular.forEach(itemHttp.id, function(id) {
               if (data[vm.configComparacion.arrayHttp.name].indexOf(id) == -1) {
                 data[vm.configComparacion.arrayHttp.name].push(id);
               }
             });
           }else{
           if (data[vm.configComparacion.arrayHttp.name].indexOf(itemHttp.id) == -1) {
             data[vm.configComparacion.arrayHttp.name].push(itemHttp.id);
           }
           }
         })
         var promEstados = estadisticaFac["getEstados"+facFn](data).$promise;
         //var promMeses = estadisticaFac["getMeses"+facFn](data).$promise;
         var promMeses = estadisticaFac["getMeses"](data).$promise;
         $q.all([promEstados, promMeses]).then(function(res) {
           vm.estados = res[0].data;
           vm.meses   = res[1].data;
           vm.mesSelected     = vm.meses[0];
           vm.estadoSelected  = vm.estados[0];
           verificarRuta();
         });
       }

       vm.init();


       vm.showDialog = function(ev, sector) {
         cuartelDialog.showDialog(ev, sector.id);
       }


       vm.startRiegoRealChart = function(data){
        vm.chartRiegoReal = new MultiChart("Riego Real");
        vm.chartRiegoRealConfig = vm.chartRiegoReal.getConfig();
        var datos = [];
        angular.forEach(data.riego, function(datoRiego, index){
          var datoRiegoVerficado = datoRiego == 0 ? null : datoRiego;
          datos.push([
            data.axis[index],
            datoRiegoVerficado
          ]);
        });
        vm.chartRiegoReal.agregarSerie({
          color       : Config.colors.riegoReal.background,
          name        : 'Riego Real',
          yAxis       : 2,
          type        : 'column',
          data        : datos,
          width       : 15,
          visibleAxis : true, //mostrar eje
          suffix      : ' mm por sector',
          preffix     : "",
          visible     : true
        });

       }


       vm.startScholanderChart = function(data){
        vm.chartScholander = new MultiChart("Bomba Scholander");
        vm.chartScholanderConfig = vm.chartScholander.getConfig();
        var datos = [];
        angular.forEach(data.scholander, function(datoScholander, index){
          var datoScholanderVerificado = datoScholander == 0 ? null : datoScholander;
          datos.push([
            data.axis[index],
            datoScholanderVerificado
          ]);
        });
        vm.chartScholander.agregarSerie({
          color       : Config.colors.scholander.background,
          name        : 'Bomba Scholander',
          yAxis       : 1,
          type        : 'spline',
          markerSymbol: 'circle',
          radius      : 6,
          data        : datos,
          lineWidth   : 2,
          visibleAxis : true, //mostrar eje
          suffix      : ' bar',
          preffix     : "-",
          visible     : true
        });

       }


       vm.startVolumenChart = function(data){
        vm.chartVolumen = new MultiChart('Volumen m<sup>3</sup> / ha');
        vm.chartVolumenConfig = vm.chartVolumen.getConfig();
        var datos = [];
        angular.forEach(data.vol, function(datoVolumen, index){
          var datoVolumenVerificado = datoVolumen == 0 ? null : datoVolumen;
          datos.push([
            data.axis[index],
            datoVolumenVerificado
          ]);
        });
        vm.chartVolumen.agregarSerie({
          color       : Config.colors.volumen.background,
          name        : 'Volumen m<sup>3</sup> / ha',
          yAxis       : 7,
          type        : 'column',
          data        : datos,
          width       : 15,
          visibleAxis : true, //mostrar eje
          suffix      : ' m<sup>3</sup>/ha',
          preffix     : "",
          visible     : true
        });

       }


        vm.startReposicionChart = function(data){
          vm.chartReposicion = new MultiChart('Reposición');
          vm.chartReposicionConfig = vm.chartReposicion.getConfig();
          var datos = [];
          angular.forEach(data.rep, function(datoReposicion, index){
            var datoReposicionVerificado = datoReposicion == 0 ? null : datoReposicion;
            datos.push([
              data.axis[index],
              datoReposicionVerificado
            ]);
          });
          vm.chartReposicion.agregarSerie({
            color       : Config.colors.riegoReal.background,
            name        : 'Reposición',
            yAxis       : 12,
            radius      : 6,
            type        : 'spline',
            markerSymbol: 'circle',
            data        : datos,
            lineWidth   : 2,
            visibleAxis : true, //mostrar eje
            suffix      : ' %',
            preffix     : "",
            visible     : true
          });

        }

        var datalabel = [3, 4, 'primer Label', 'Label 2'];

        vm.startPrecipitacionChart = function(data){
          vm.chartPrecipitacion = new MultiChart('Precipitación');
          vm.chartPrecipitacionConfig = vm.chartPrecipitacion.getConfig();
          var datos = [];
          angular.forEach(data.precip, function(datoPrecipitacion, index){
            var datoPrecipitacionVerificado = datoPrecipitacion == 0 ? null : datoPrecipitacion;
            datos.push([
              data.axis[index],
              datoPrecipitacionVerificado
            ]);
          });

          vm.chartPrecipitacion.agregarSerie({
          color       : Config.colors.precipitacion.background,
          name        : 'Precipitación (promedio)',
          yAxis       : 2,
          type        : 'column',
          data        : datos,
          width       : 15,
          visibleAxis : true, //mostrar eje
          suffix      : ' mm',
          preffix     : "",
          visible     : true,
          labelsData      : datalabel,
          labelsColor: '#FF0000'
        });

        }


        vm.startEtAcumuladaChart = function(data){
          vm.chartEtAcumulada = new MultiChart('ET0 Acumulada');
          vm.chartEtAcumuladaConfig = vm.chartEtAcumulada.getConfig();
          var datos = [];
          angular.forEach(data.et, function(datoEtAcumulada, index){
            var datoEtAcumuladaVerificado = datoEtAcumulada == 0 ? null : datoEtAcumulada;
            datos.push([
              data.axis[index],
              datoEtAcumuladaVerificado
            ]);
          });
        var datalabel = [3, 4, 43, 'hola'];

          vm.chartEtAcumulada.agregarSerie({
            color       : Config.colors.etAcumulado.background,
            name        : 'ET0 Acumulado',
            yAxis       : 2,
            type        : 'spline',
            markerSymbol: 'circle',
            radius      : 6,
            data        : datos,
            lineWidth   : 1,
            visibleAxis : true, //mostrar eje
            suffix      : ' mm',
            preffix     : "",
            visible     : true,
          labelsData  : datalabel,
          labelsColor : '#0000FF'
          });
        }


     }]);

   })();
